import { helpers } from 'app-webtech-core';
import { SET_CONFIG } from './types';

export const setEmbedConfig = helpers.actions.actionCreator(SET_CONFIG);
